import { Validations } from "./validations";

export default class ValidationError {
  public message: string;

  public source: Validations;

  public sourceName?: string;

  public constructor(
    message: string,
    source: Validations,
    sourceName?: string
  ) {
    this.message = message;
    this.source = source;
    this.sourceName = sourceName;
  }
}
